import scrollLock from 'scroll-lock';
import { gsap } from 'gsap';

export default class Menu {
	static init(){
		const headerWrapper = document.querySelector('.c-header');
		new Menu(headerWrapper);
	}

	constructor(headerWrapper){

		this.headerWrapper = headerWrapper;
		this.openMenuBtn = this.headerWrapper.querySelector('.c-hamburger');
		this.menuWrap = document.querySelector('.c-menu__inner');
		this.menu = document.querySelector('.c-menu--main-nav');
		this.overlayPath = document.querySelector('.c-overlay__path');
		this.menuItems = this.menuWrap.querySelectorAll('.menu-item');
		this.headerInner = this.headerWrapper.querySelector('.c-header__inner');
		this.filter = document.querySelector('[data-pronouns-filter]');

		if (!this.openMenuBtn) return;

		this.menuOpen = false;

		this.isAnimating = false;

		// animate search field on mobile
		this.breakpoint = window.matchMedia('(max-width:768px)');
		this.searchFormWrapper = this.headerWrapper.querySelector('[data-search-form]');

		if (this.breakpoint.matches === true) {
			this.searchFormWrapper.addEventListener('click', e => {
				this.headerWrapper.classList.add('search-form-is-expanded');
				const searchForm = e.target.closest('.c-search-form');
				searchForm.classList.add('is-expanded');
			});
		}

		this.openMenuBtn.addEventListener('click', e => {
			this.toggleMenu();
			this.headerWrapper.classList.remove('has-background--white');
		});

		let FocusableElements = this.menu.querySelectorAll('li');

		const firstTarget = FocusableElements[0];
		const lastTarget = FocusableElements[FocusableElements.length - 1];

		const firstFocusableEl = firstTarget.firstElementChild;
		const lastFocusableEl = lastTarget.firstElementChild;

		window.addEventListener('keydown', e => {

			if (e.key === 'Escape') {
				this.closeMenu();
			}

			if (e.key === 'Tab' || e.key === 9) {
				if ( e.shiftKey ) /* shift + tab */ {
					if (document.activeElement === firstFocusableEl) {
						lastFocusableEl.focus();
						e.preventDefault();
					}
				} else /* tab */ {
					if (document.activeElement === lastFocusableEl) {
						firstFocusableEl.focus();
						e.preventDefault();
					}
				}
			}
		});
	}

	toggleMenu() {
		this.menuOpen ? this.closeMenu() : this.openMenu();
	}

	openMenu() {

		if ( this.isAnimating ) return;

		this.menuOpen = true;

		this.isAnimating = true;

		scrollLock.disablePageScroll();

		this.menu.classList.add('is-active');
		this.openMenuBtn.classList.add('is-active');
		this.openMenuBtn.setAttribute('aria-expanded', true);
		this.openMenuBtn.setAttribute('aria-label', 'close menu');

		gsap.timeline({
			onComplete: () => this.isAnimating = false
		})

		.set(this.overlayPath, {
			attr: { d: 'M 0 100 V 100 Q 50 100 100 100 V 100 z' }
		})
		.to(this.overlayPath, {
			duration: 0.8,
			ease: 'power4.in',
			attr: { d: 'M 0 100 V 50 Q 50 0 100 50 V 100 z' }
		}, 0)
		.to(this.filter, {
			duration: 0.8,
			ease: 'power4.in',
			opacity: 0,
		}, "<")
		.to(this.headerInner, {
			duration: 0.8,
			ease: 'power4.in',
			opacity: 0,
		}, 0)
		.to(this.overlayPath, {
			duration: 0.3,
			ease: 'power2',
			attr: { d: 'M 0 100 V 0 Q 50 0 100 0 V 100 z' },
			onComplete: () => {
				this.menuWrap.classList.add('is-open');
				document.body.classList.add('has-menu-open');
			}
		})

		// now reveal
		.set(this.menuItems, {
			opacity: 0
		})
		.set(this.overlayPath, {
			attr: { d: 'M 0 0 V 100 Q 50 100 100 100 V 0 z' }
		})
		.to(this.overlayPath, {
			duration: 0.3,
			ease: 'power2.in',
			attr: { d: 'M 0 0 V 50 Q 50 0 100 50 V 0 z' }
		})
		.to(this.overlayPath, {
			duration: 0.8,
			ease: 'power4',
			attr: { d: 'M 0 0 V 0 Q 50 0 100 0 V 0 z' }
		})
		.to(this.headerInner, {
			duration: 1,
			ease: 'power4.inOut',
			opacity: 1,
		})
		.to(this.menuItems, {
			duration: 1.1,
			ease: 'power4',
			startAt: {y: 150},
			y: 0,
			opacity: 1,
			stagger: 0.05
		}, '>-=1.1');
	}

	closeMenu() {
		if ( this.isAnimating ) return;

		this.menuOpen = false;

		this.isAnimating = true;

		scrollLock.enablePageScroll();

		setTimeout(() => {
			document.body.classList.remove('has-menu-open');
		}, 300)


		this.menu.classList.remove('is-active');

		this.openMenuBtn.classList.remove('is-active');
		this.openMenuBtn.setAttribute('aria-expanded', false);
		this.openMenuBtn.setAttribute('aria-label', 'open menu');
		this.openMenuBtn.focus();

    	gsap.timeline({
            onComplete: () => this.isAnimating = false
        })

        .set(this.overlayPath, {
            attr: { d: 'M 0 0 V 0 Q 50 0 100 0 V 0 z' }
        })
        .to(this.overlayPath, {
            duration: 0.8,
            ease: 'power4.in',
            attr: { d: 'M 0 0 V 50 Q 50 100 100 50 V 0 z' }
        }, 0)
        .to(this.overlayPath, {
            duration: 0.3,
            ease: 'power2',
            attr: { d: 'M 0 0 V 100 Q 50 100 100 100 V 0 z' },
            onComplete: () => {
                this.menuWrap.classList.remove('is-open');
            }
        })

        // now reveal
        .set(this.overlayPath, {
            attr: { d: 'M 0 100 V 0 Q 50 0 100 0 V 100 z' }
        })
        .to(this.overlayPath, {
            duration: 0.3,
            ease: 'power2.in',
            attr: { d: 'M 0 100 V 50 Q 50 100 100 50 V 100 z' }
        })
        .to(this.overlayPath, {
            duration: 0.8,
            ease: 'power4',
            attr: { d: 'M 0 100 V 100 Q 50 100 100 100 V 100 z' }
        })
		.to(this.filter, {
			duration: 0.8,
			ease: 'power4.in',
			opacity: 1,
		}, "<")

		// menu items translate animation
		.to(this.menuItems, {
			duration: 0.8,
			ease: 'power2.in',
			y: 100,
			opacity: 0,
			stagger: -0.05
		}, 0)
	}
}
